<template>
    <div>
        <div class="list-title">
            <div>序号</div>
            <div>试卷名称</div>
            <div>开始时间</div>
            <div>结束时间</div>
            <div></div>
        </div>
        <div v-if="list===null">暂无数据</div>
        <div class="list" v-for="(l,index) in list" :key="l.id">
            <div>{{index+1}}</div>
            <div>{{l.name}}</div>
            <div>{{common.formDataToHms(l.startTime)}}</div>
            <div>{{common.formDataToHms(l.endTime)}}</div>
            <div>
                <div v-if="new Date(l.endTime).getTime()<new Date().getTime()">已结束</div>
                <div v-else>
                    <button class="check-btn" @click="openInfo(l)" v-if="l.examCount===0">开始答卷</button>
                    <div v-if="l.examCount>0" @click="openInfo(l)" >已提交</div>
                </div>
            </div>
        </div>
        <Pagination
                :size=total
                :pageLimit=pageInfo.pageObject.pageSize
                style="margin:20px 0"
                v-on:changeCurrent="changeCurrent"></Pagination>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        name: "MyExam",
        components:{Pagination},
        data(){
            return{
                list: [],
                pageInfo:{
                    pageObject:{
                        currentPage:1,
                        pageSize: 8
                    },
                    orderField:"start_time desc",
                },
                total:0
            }
        },
        created() {
            this.getAllPaper(this.pageInfo);
        },
        methods:{
            openInfo(l){
                localStorage.setItem("endTime",new Date(l.endTime).getTime());
                //比较当前时间与考试时间
                let date = new Date(l.startTime);
                if(date.getTime()>new Date().getTime()){
                    this.$message("还没到考试时间");
                    return false;
                }
                else {
                    this.$json("/examination/paper/"+l.id,"GET",{}).then(res=>{
                        localStorage.setItem("examPaper",JSON.stringify(res.data));
                        localStorage.setItem("examStartTime",this.common.formatDateAndTime(new Date(),"/"));
                        window.open("/ExamPaper/"+l.id);
                    });
                }
            },
            changeCurrent(data){
                this.pageInfo.pageObject.currentPage = data;
                this.getAllPaper(this.pageInfo);
            },
            getAllPaper(pageInfo){
                this.$json("/examination/list","POST",pageInfo).then(res =>{
                    this.list=res.data;
                    this.total = res.total;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/css/myCourse.less';
    .list:nth-child(odd), .list-title {
        background-color: #edf5ff;
    }
</style>
